import React from 'react';
import Indexs from './index';
import Title from '../../title';
import Permission from '../../../functions/permission';

class Invoice extends React.Component {

  state = {
    menuPermission: []
  }

  componentDidMount() {
    this.getPermission();
  }

  getPermission() {
    if (this.props.type == 'quotation') {
      let menuPermission = Permission('invoice', this.props.menus);
      this.setState({ menuPermission })
    }
    else {
      let menuPermission = Permission('quotation', this.props.menus);
      this.setState({ menuPermission })
    }
  }

  render() {
    return (
      <div>
        <Title title={'Quotation'} openDrawer={this.props.openDrawer} />
        { this.state.menuPermission.view ?
          (
            <div>
              <Indexs type="invoice" display1='none' viewcontrol={this.state.viewcontrol}
              editcontrol={this.state.editcontrol} display={this.state.exportcontrol}
              cancelcontol={this.state.quotationcancel} menuPermission={this.state.menuPermission}
              menus={this.props.menus} columnName={'Quotation No'} value="Q" />
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Invoice;
